import React from 'react'
import { useDispatch } from 'react-redux'
import { itemPhotoRemoveRequest, roomPhotoRemoveRequest, showPhotoViewer } from '../../store/photos/slice'
import { IPhotos } from '../../store/photos/types'
import PhotoThumb from '../PhotoThumb'
import { Container } from './styles'
import { useTranslation, } from 'react-i18next';
import { systemAddDialog } from '../../store/system/slice'
import { roomFloorPlanDeleteRequest, roomFrequencyAnalysisDeleteRequest } from '../../store/sweeps/slice'


interface Props {
    photos: IPhotos[],
    type: 'room' | 'item' | 'floorplan' | 'video' | 'frequencyAnalysis';
    parentId: string;
    sweepId: string;
}
const PhotoGallery: React.FC<Props> = ({ photos, type, parentId, sweepId }) => {

    const { t } = useTranslation();

    const dispatch = useDispatch()

    return <Container >
        {photos.map((photo, index) => <PhotoThumb key={`photo-${photo.id}`} src={`${photo.link}&width=120&height=120`}
            onDelete={() => {
                dispatch(systemAddDialog({
                    title: t("pages.photos.dialogs.remove_photo"),
                    message: t("pages.photos.dialogs.remove_photo_message"),
                    actions: [{
                        text: t("pages.photos.buttons.remove_photo_confirm"),
                        action: () => {
                            switch (type) {
                                case 'room':
                                    dispatch(roomPhotoRemoveRequest({
                                        roomId: parentId,
                                        photoId: photo.id
                                    }))
                                    break;
                                case 'floorplan':
                                    dispatch(roomFloorPlanDeleteRequest({
                                        roomId: parentId,
                                        sweepId: sweepId
                                    }))
                                    break;
                                case 'frequencyAnalysis':
                                    dispatch(roomFrequencyAnalysisDeleteRequest({
                                        roomId: parentId,
                                        sweepId: sweepId
                                    }))
                                    break;
                                case 'item':
                                    dispatch(itemPhotoRemoveRequest({
                                        itemId: parentId,
                                        photoId: photo.id
                                    }))
                                    break;
                                default:
                                    break;
                            }
                        },
                        color: 'danger',
                        prependIcon: 'trash'
                    },
                    {
                        text: t("pages.photos.buttons.remove_photo_cancel"),
                        action: () => { },
                        color: 'none'
                    }]
                }));
            }}
            onOpen={() => {
                dispatch(showPhotoViewer({
                    arrayPhoto: photos.map((photo) => photo.link),
                    positionPhoto: index
                }))
            }} />)}
    </Container>
}

export default PhotoGallery;